/* ============
 * Packaging Excise
 * ============
 *
 * All packaging group excises
 */

import Vue from 'vue';
import store from './../../store';
import exciseGroupTransformer from './../../transformers/exciseGroup';

const success = ({ data }, resolve) => {
  const excisePackagingGroups = exciseGroupTransformer.fetchCollection(data.data);
  store.dispatch('fetchExcisePackagingGroup', { excisePackagingGroups });
  resolve();
};

const failed = () => {
};

// Display cities related to a country.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('groups/packaging')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/exciseGroup/packaging.js